$(document).ready(function () {

    if ($(".similar-communities-comparison" + " .my-slider").length) {
        var sliderSimilarCommunities = tns({
            container: ".similar-communities-comparison" + " .my-slider",
            items: 3,
            slideBy: 'page',
            autoplay: false,
            loop: false,
            
            controlsContainer: ".similar-communities-comparison" + " .similar-communities-comparison-slider-controls",
            responsive: {

                0: {
                    items: 1,
                    gutter: 10,
                  
                },

                640: {
                    items: 1,
                    gutter: 10,
                  
                },

                768: {
                    items: 2,
                    gutter: 10,
                    
                },
                1024: {
                    items: 3,
                    gutter: 10,
                   
                }
                ,
                1200: {
                    items: 3,
                    gutter: 10,
                   
                },
                1440: {
                    items: 3,
                    gutter: 10,
                  
                }
            }
        });
    }

    

    $(document).on("click", ".similar-communities-comparison-slider-controls" + " .slider-controls-button", function () {
        var sliderInfo = sliderSimilarCommunities.getInfo();

         if (sliderInfo.pages == 3) {

            if (sliderInfo.navCurrentIndex == 0) {
                $(".similar-communities-comparison" + " .prev").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .prev").removeClass("hide");
            }

            if (sliderInfo.navCurrentIndex == 2) {
                $(".similar-communities-comparison" + " .next").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .next").removeClass("hide");
            }
        
        } else if (sliderInfo.pages == 2) {

            if (sliderInfo.navCurrentIndex == 0) {
                $(".similar-communities-comparison" + " .prev").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .prev").removeClass("hide");
            }

            if (sliderInfo.navCurrentIndex == 1) {
                $(".similar-communities-comparison" + " .next").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .next").removeClass("hide");
            }
        }else{

            if (sliderInfo.navCurrentIndex == 0) {
                $(".similar-communities-comparison" + " .prev").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .prev").removeClass("hide");
            }

            if (sliderInfo.navCurrentIndex == 5) {
                $(".similar-communities-comparison" + " .next").addClass("hide");
            } else {
                $(".similar-communities-comparison" + " .next").removeClass("hide");
            }

        } 

    });
});

